import React from 'react';

export const DataDeletion: React.FC = () => {
  return (
    <div className="marketing-shell legal-page pt-32 md:pt-36 pb-24 bg-[#f6f8f7]">
      <div className="container mx-auto px-4 max-w-4xl">
        <p className="text-sm font-bold text-[#087064] uppercase tracking-[0.2em] mb-4">Privacidad y control</p>
        <h1 className="text-4xl md:text-5xl font-black text-[#10232d] mb-8">Eliminación de Datos</h1>
        <div className="prose prose-slate max-w-none">
          <p className="text-[#536970] mb-10">
            En ANCORA AUTOMATIONS respetamos tu derecho al olvido. Puedes solicitar la eliminación completa de tus datos en cualquier momento.
          </p>

          <section className="py-8 border-t border-[#d7e4e2]">
            <h2 className="text-xl font-bold text-[#10232d] mb-4">Cómo solicitar la eliminación</h2>
            <p className="text-[#536970]">
              Envía un email a automatiza@ancoraautomations.es con el asunto "Solicitud de eliminación de datos" incluyendo:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-1 text-[#536970]">
              <li>Nombre completo</li>
              <li>Email asociado a tu cuenta</li>
              <li>Teléfono</li>
              <li>Motivo de la solicitud (opcional)</li>
            </ul>
          </section>

          <section className="py-8 border-t border-[#d7e4e2]">
            <h2 className="text-xl font-bold text-[#10232d] mb-4">Plazo de eliminación</h2>
            <p className="text-[#536970]">
              Procesamos las solicitudes de eliminación en un plazo máximo de 30 días hábiles. Recibirás confirmación por email una vez completada.
            </p>
          </section>

          <section className="py-8 border-t border-[#d7e4e2]">
            <h2 className="text-xl font-bold text-red-700 mb-4">Importante: Consecuencias de la eliminación</h2>
            <ul className="list-disc pl-6 mb-4 space-y-1 text-[#536970]">
              <li>Perderás acceso a todos los servicios contratados</li>
              <li>Se eliminarán todos tus datos personales</li>
              <li>Se eliminarán las configuraciones del chatbot</li>
              <li>Esta acción no se puede deshacer</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};
